import { createFileRoute } from '@tanstack/react-router'
import { LeaguePage, type LeagueSearch, type LeagueView } from '~/features/league/LeaguePage'
import { scorersQuery, suspensionsQuery, tableQuery } from '~/features/league/queries'
import { loaderScope } from '~/features/matches/queries'

const VIEWS: LeagueView[] = ['gesamt', 'heim', 'auswaerts', 'fairplay', 'sperren', 'torjaeger']

export const Route = createFileRoute('/_app/liga/')({
  validateSearch: (s: Record<string, unknown>): LeagueSearch => (VIEWS.includes(s.ansicht as LeagueView) && s.ansicht !== 'gesamt' ? { ansicht: s.ansicht as LeagueView } : {}),
  loaderDeps: ({ search }) => ({ view: search.ansicht }),
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId || !scope.permissions.includes('matches.read')) return
    const qc = context.queryClient
    await Promise.all([
      qc.ensureQueryData(tableQuery(scope.teamId, scope.season)),
      deps.view === 'sperren' ? qc.ensureQueryData(suspensionsQuery(scope.teamId, scope.season)) : undefined,
      deps.view === 'torjaeger' ? qc.ensureQueryData(scorersQuery(scope.teamId, scope.season)) : undefined,
    ])
  },
  component: function Liga() {
    return <LeaguePage search={Route.useSearch()} />
  },
})
